export default __webpack_public_path__ + "static/media/error.be84a793.svg";